import type { CompanySocialPlatform } from "./company-social-platforms";

export const SOCIAL_PLATFORM_LABELS: Record<CompanySocialPlatform, string> = {
	facebook: "Facebook",
	twitter: "X",
	instagram: "Instagram",
	linkedin: "LinkedIn",
	youtube: "YouTube",
	tiktok: "TikTok",
	pinterest: "Pinterest",
	snapchat: "Snapchat",
	threads: "Threads",
	whatsapp: "WhatsApp",
};

export type SharePlatform = "twitter" | "facebook" | "linkedin" | "email" | "whatsapp";

export type ShareItem = {
	key: SharePlatform;
	label: string;
	href: string;
	external?: boolean;
};

export function createSocialShareItems(url: string, title: string, labels: Record<SharePlatform, string>): ShareItem[] {
	const encodedTitle = encodeURIComponent(title);
	const encodedUrl = encodeURIComponent(url);

	const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
	const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
	const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
	const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${title}\n${url}`)}`;
	const mailUrl = `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(`View this website: ${url}`)}`;

	return [
		{ key: "twitter", label: labels.twitter, href: twitterUrl, external: true },
		{ key: "facebook", label: labels.facebook, href: facebookUrl, external: true },
		{ key: "linkedin", label: labels.linkedin, href: linkedinUrl, external: true },
		{ key: "email", label: labels.email, href: mailUrl },
		{ key: "whatsapp", label: labels.whatsapp, href: whatsappUrl },
	];
}
